import { action, observable } from 'mobx';
import { StoreLocatorSidebarPdpData, StoreLocatorSidebarState, StoreLocatorType } from './storeLocatorTypes';

export const storeLocatorSidebarState = observable<StoreLocatorSidebarState>({
  isOpen: false,
  data: null,
  title: '',
});

export const openStoreLocatorSidebar = action(
  ({
    feature = 'fis',
    pdpProps,
    page = 'pdp',
  }: {
    feature: StoreLocatorType;
    pdpProps?: StoreLocatorSidebarPdpData;
    page: 'pdp' | 'cart';
  }) => {
    storeLocatorSidebarState.isOpen = true;
    storeLocatorSidebarState.title = feature === 'fis' ? 'Find in Store' : 'Pick up in store';
    storeLocatorSidebarState.data = {
      product: pdpProps?.product,
      selectedVariant: pdpProps?.selectedVariant,
      userSelectedSize: pdpProps?.userSelectedSize,
      storeLocatorType: feature,
      isAvailableOnline: pdpProps?.isAvailableOnline,
      page,
      ...(feature === 'bopis' ? { storeSelectionEnabled: true } : {}),
    };
  }
);

export const closeStoreLocatorSidebar = action(() => {
  storeLocatorSidebarState.isOpen = false;
  storeLocatorSidebarState.data = null;
  storeLocatorSidebarState.title = '';
});
